import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AnchorComponent } from './anchor.component';
import { LocaleDirectiveModule } from '@finder/shared/directives/locale/locale.module';
import { LinkIdDirectiveModule } from '@finder/shared/directives/link-id/link-id.module';

@NgModule({
    imports: [
        CommonModule,
        LocaleDirectiveModule,
        LinkIdDirectiveModule,
        RouterModule,
    ],
    declarations: [
        AnchorComponent
    ],
    providers: [],
    exports: [
        AnchorComponent
    ]
})
export class AnchorModule {
    static entry = AnchorComponent;
}
